import clsx from 'clsx';

import { Icon } from '@/ui';

import type { CoachProfile } from '@/types';
import type { FC } from 'react';

import Card from '@/components/Profile/Card';

const CAL_URL = import.meta.env.VITE_CAL_URL;

interface CalProps {
  hideAvailability?: boolean;
  schedulingProvider?: CoachProfile['schedulingProvider'];
  username?: string;
}

const Cal: FC<CalProps> = ({
  hideAvailability,
  schedulingProvider,
  username,
}) => {
  const usesMoments = schedulingProvider === 'moments';
  const hasCalUrl = !usesMoments && !!username;
  let title = 'Scheduling not setup';
  if (username) title = `${CAL_URL}/${username}`;
  if (usesMoments) title = 'Moments';

  return (
    <>
      {!hideAvailability && !usesMoments && (
        <Card icon="calendar_month" title="Coaching hours availability">
          <a
            className="button-label flex items-center gap-2 text-sage-600"
            href={`${CAL_URL}/availability`}
            rel="noreferrer"
            target="_blank"
          >
            View and edit
            <Icon>open_in_new</Icon>
          </a>
        </Card>
      )}
      <Card
        className={clsx({
          '!bg-poppy-100': !usesMoments && !username,
        })}
        icon="public"
        title={title}
      >
        {hasCalUrl && (
          <a
            className="button-label flex items-center gap-2 text-sage-600"
            href={`${CAL_URL}/${username}`}
            rel="noreferrer"
            target="_blank"
          >
            View
            <Icon>open_in_new</Icon>
          </a>
        )}
      </Card>
    </>
  );
};

export default Cal;
